import MapoContentManagement from 'components/MapoAdministration/components/Content-Management/MapoContentManagement';

const ScreenMapoContentManagement = () => <MapoContentManagement />;

export default ScreenMapoContentManagement;
